//import { triggerEventCustom } from '../../remote-education/remote-education-utils';
import { useEffect } from 'react';
import { User } from '../../../shared/types/generated';
import { triggerEventCustom } from '../../remote-education/remote-education-utils';
import { DOMAIN_SITE_URL } from '../../../shared/constans';

export const EventAfterBuy: React.FC<{
  type: string;
  user?: User;
}> = ({ type, user }) => {
  useEffect(() => {
    let event = '';
    if (user && user?.email && user?.id && user?.name) {
      //const email = user.email;
      const id = user.id;
      //const name = user.name;
      switch (type) {
        case 'monthly-sub':
          event = `{
'event': 'subscription_payment',
'pagePath': '${DOMAIN_SITE_URL}/planes',
'planName': 'Mensual',
'price': '100',
'ID': '${id}',
}`;
          break;
        case 'student-sub':
          event = `{
'event': 'subscription_payment',
'pagePath': '${DOMAIN_SITE_URL}/planes',
'planName': 'Estudiantil o Docente',
'price': '55',
'ID': '${id}',
}`;
          break;
        case 'yearly-sub':
          event = `{
'event': 'subscription_payment',
'pagePath': '${DOMAIN_SITE_URL}/planes',
'planName': 'Anual',
'price': '1000',
'ID': '${id}',
}`;
          break;
      }
      triggerEventCustom(event);
      //console.log({event});
    }
  }, [user, type]);
  if (!user) {
    return null;
  }
  return <></>;
};
